export default function Footer() {
    return (
        <>
            <ul className="auth-footer">
            </ul>
            <p className="footer-text text-center mt-5">copyright © 2024 Shivaami. All rights reserved.</p>
        </>
    )
}